import EventBus from '@/events/EventBus';
import {shuffleArray} from '@/helper/ArrayHelper';
import {createUrlSearchParamsFromObject} from '@/helper/QueryHelper';
import TypesenseMixin from '@/mixins/TypesenseMixin';

export default {
  mixins: [TypesenseMixin],
  data() {
    return {
      loading: true,
      jobPostingIds: [],
      mergedJobPostings: [],
      page: 1,
      // URL-String mit Filter-Parametern; wird intern verwendet und gesetzt und ist daher nicht Bestandteil von filterConfig!
      filterParams: '',
      filterConfig: {
        // Damit können zusätzliche Filter "von außen" definiert werden, z.B. für TopOffers
        additionalFilterParams: new URLSearchParams(),
        // Objekt der FilterParams einer Section mit Werten die in Strapi definiert werden können
        sectionFilterParams:
          this.section && this.section.filterParams
            ? this.section.filterParams
            : {},
        // definiert ob die ermittelten TopTeaser auch nach den fullFilterParams ermittelt werden sollen oder davon unabhängig
        filteredTopTeaser: false,
        // definiert ob die ermittelten InstantTeaser auch nach den fullFilterParams ermittelt werden sollen oder davon unabhängig
        filteredInstantTeaser: true,
        // definiert ob die ermittelten InstantTeaser auch nach den fullFilterParams ermittelt werden sollen oder davon unabhängig
        filteredHomepageTeaser: true,
        // definiert ob die Rückgabe nur einen InstantTeaser-Job beinhalten soll oder alle
        sliceInstantTeaser: true,
        // definiert ob die Jobs mit Bewerbung ausgeschlossen werden sollen; funktioniert noch nicht!
        excludeNotYetAppliedTo: false,
        // definiert ob normale JobPostings mit ermittelt werden sollen
        getDefaultJobPostings: true,
        // definiert ob TopTeaser mit ermittelt werden sollen
        getTopTeaserJobPostings: true,
        // definiert ob InstantTeaser mit ermittelt werden sollen
        getHomepageTeaserJobPostings: true,
        // definiert ob InstantTeaser mit ermittelt werden sollen
        getInstantTeaserJobPostings: true,
        // Anzahl der Jobs die insgesamt ermittelt werden soll
        numJobPostings: 50,
        // Anzahl auf die das Ergebnis reduziert werden soll
        shuffleAndSlice: 5,
      },
      orderByDefault: {key: 'order_number', direction: 'desc'},
    };
  },
  async fetch() {
    await this.fetchJobPostings();
  },
  computed: {
    filterParamsObjectFromSection() {
      const filterParams = {};
      if (
        this.filterConfig.sectionFilterParams &&
        this.filterConfig.sectionFilterParams.search
      ) {
        filterParams.search = this.filterConfig.sectionFilterParams.search;
      }
      if (
        this.filterConfig.sectionFilterParams &&
        this.filterConfig.sectionFilterParams.activities
      ) {
        filterParams['activity[]'] =
          this.filterConfig.sectionFilterParams.activities
            .split(',')
            .map((value) => value.trim());
      }
      if (
        this.filterConfig.sectionFilterParams &&
        this.filterConfig.sectionFilterParams.latitude &&
        this.filterConfig.sectionFilterParams.longitude &&
        this.filterConfig.sectionFilterParams.distance
      ) {
        filterParams.distance = `${this.filterConfig.sectionFilterParams.latitude},${this.filterConfig.sectionFilterParams.longitude},${this.filterConfig.sectionFilterParams.distance}`;
      }

      return filterParams;
    },
    forcedFilterParams() {
      const forcedFilterParams = new URLSearchParams();
      if (
        this.filterConfig.sectionFilterParams &&
        this.filterConfig.sectionFilterParams.tags
      ) {
        this.filterConfig.sectionFilterParams.tags
          .split(',')
          .forEach((value) => {
            forcedFilterParams.append('tagsOr[]', value.trim());
          });
      }
      return forcedFilterParams.toString();
    },
    fullFilterParams() {
      const params = [
        this.filterParamsWithMyFilters,
        this.forcedFilterParams,
        this.filterConfig.additionalFilterParams instanceof URLSearchParams
          ? this.filterConfig.additionalFilterParams.toString()
          : '',
      ].filter((param) => param !== ''); // Filtert leere Strings

      return params.join('&');
    },
    itemsPerPage() {
      return Math.min(100, this.filterConfig.numJobPostings);
    },
  },
  created() {
    if (process.client) {
      EventBus.$on('login', this.fetchJobPostings);
      EventBus.$on('logout', this.fetchJobPostings);

      EventBus.$on('applied-on-job', this.fetchJobPostings);
    }
  },
  destroyed() {
    if (process.client) {
      EventBus.$off('login', this.fetchJobPostings);
      // this breaks!??? WHY!????
      // EventBus.$off('logout', this.fetchJobPostings);
      // This works though
      EventBus.$off('logout');

      EventBus.$off('applied-on-job', this.fetchJobPostings);
    }
  },
  methods: {
    generateFilterParams() {
      const urlSearchParams = createUrlSearchParamsFromObject(
        this.filterParamsObjectFromSection
      );
      urlSearchParams.sort();
      this.filterParams = urlSearchParams.toString();
    },
    async fetchJobPostings() {
      // Es müssen keine Jobs ermittelt werden wenn die erforderliche Anzahl an Jobs bereits vorliegt
      if (this.jobPostingIds.length >= this.filterConfig.numJobPostings) {
        return;
      }

      this.generateFilterParams();

      const getParameters = new URLSearchParams();
      getParameters.set(
        'query_by',
        'job_id,name,number,activity_translated,industry_translated,company,short_description,description,location,requirement'
      );
      getParameters.set('query_by_weights', '4,4,4,4,4,4,3,1,1,1');
      getParameters.set('include_fields', 'id');

      const searches = [];

      const fullFilterParams = new URLSearchParams(this.fullFilterParams);

      if (this.filterConfig.getDefaultJobPostings) {
        const postParameters =
          this.convertFilterParamsToTypesense(fullFilterParams);
        postParameters.set('collection', 'job_posting');
        postParameters.set('per_page', this.itemsPerPage);
        postParameters.set('page', this.page);
        //postParameters.set('sort_by', 'date(missing_values: last):desc');

        postParameters.set(
          'sort_by',
          `${this.orderByDefault.key}(missing_values: last):${this.orderByDefault.direction}`
        );

        searches.push(postParameters);
      }

      if (this.filterConfig.getTopTeaserJobPostings) {
        let postParametersTopTeaser = new URLSearchParams();

        // Ob bei TopTeasern die Filter berücksichtigt werden sollen ist nun konfigurierbar
        if (this.filterConfig.filteredTopTeaser) {
          const topTeaserFilterParams = new URLSearchParams(
            this.fullFilterParams
          );
          // Sonderfall: Bei TopTeasern sollen additionalFilters nicht mit berücksichtigt werden
          topTeaserFilterParams.delete('additionalFilters');
          postParametersTopTeaser = this.convertFilterParamsToTypesense(
            topTeaserFilterParams
          );
        }

        postParametersTopTeaser.set('collection', 'job_posting_top_job');
        postParametersTopTeaser.set('q', '*');
        postParametersTopTeaser.set('per_page', '100');
        postParametersTopTeaser.set('page', '1');
        searches.push(postParametersTopTeaser);
      }

      if (this.filterConfig.getInstantTeaserJobPostings) {
        let postParametersInstantTeaser = new URLSearchParams();

        // Ob bei InstantTeasern die Filter berücksichtigt werden sollen ist nun konfigurierbar
        if (this.filterConfig.filteredInstantTeaser) {
          const instantTeaserFilterParams = new URLSearchParams(
            this.fullFilterParams
          );
          // Sonderfall: Bei InstantTeasern sollen additionalFilters nicht mit berücksichtigt werden
          instantTeaserFilterParams.delete('additionalFilters');
          postParametersInstantTeaser = this.convertFilterParamsToTypesense(
            instantTeaserFilterParams
          );
        }

        postParametersInstantTeaser.set(
          'collection',
          'job_posting_instant_teaser'
        );
        postParametersInstantTeaser.set('q', '*');
        postParametersInstantTeaser.set('per_page', '100');
        postParametersInstantTeaser.set('page', '1');
        searches.push(postParametersInstantTeaser);
      }

      if (this.filterConfig.getHomepageTeaserJobPostings) {
        let postParametersHomepageTeaser = new URLSearchParams();

        // Ob bei HomepageTeasern die Filter berücksichtigt werden sollen ist nun konfigurierbar
        if (this.filterConfig.filteredHomepageTeaser) {
          const homepageTeaserFilterParams = new URLSearchParams(
            this.fullFilterParams
          );
          // Sonderfall: Bei HomepageTeasern sollen additionalFilters nicht mit berücksichtigt werden
          homepageTeaserFilterParams.delete('additionalFilters');
          postParametersHomepageTeaser = this.convertFilterParamsToTypesense(
            homepageTeaserFilterParams
          );
        }

        postParametersHomepageTeaser.set(
          'collection',
          'job_posting_homepage_teaser'
        );
        postParametersHomepageTeaser.set('q', '*');
        postParametersHomepageTeaser.set('per_page', '100');
        postParametersHomepageTeaser.set('page', '1');
        searches.push(postParametersHomepageTeaser);
      }

      const typesenseSearches = searches.map((search) =>
        Object.fromEntries(search)
      );

      if (process.client) {
        await this.$localforage.setItem(
          'TypesenseBoxParams',
          typesenseSearches[0]
        );
      }

      const results = (
        await this.$store.dispatch(
          'api/jobPosting/getJobPostingsFromTypesenseMultisearch',
          {
            getParameters,
            searches: typesenseSearches,
          }
        )
      ).results;

      const apiGetParameters = new URLSearchParams();
      apiGetParameters.append('itemsPerPage', this.itemsPerPage);
      let idsToGet = [];
      const addHitToIdArray = (item) => {
        if (idsToGet.indexOf(item.document.id) === -1)
          idsToGet.push(item.document.id);
      };

      results.forEach((result) => result.hits.forEach(addHitToIdArray));

      if (idsToGet.length > 0) {
        if (
          this.filterConfig.shuffleAndSlice &&
          this.filterConfig.shuffleAndSlice > 0
        ) {
          idsToGet = shuffleArray(idsToGet).slice(
            0,
            this.filterConfig.shuffleAndSlice
          );
        }

        idsToGet.forEach((id) => apiGetParameters.append('id[]', id));

        const jobPostings = (
          await this.$store.dispatch(
            'api/jobPosting/getJobPostings',
            apiGetParameters
          )
        ).data;

        jobPostings.forEach((jobPosting) => {
          if (
            this.mergedJobPostings.length < this.filterConfig.numJobPostings
          ) {
            if (!this.jobPostingIds.includes(jobPosting.id)) {
              this.jobPostingIds.push(jobPosting.id);
              this.mergedJobPostings.push(jobPosting);
            }
          }
        });
      }

      this.loading = false;
    },
  },
};
